import { bindAll } from 'bind-event-listener';
import { TeamsExperienceTracker } from './teams-experience-tracker';
import { computeErrorAttributes, computePerformanceAttributes, isNetworkError } from './utils';
export function createTeamsExperienceTracker(fireExperienceEvent, options) {
  const tracker = new TeamsExperienceTracker({
    isNetworkOfflineError: isNetworkError
  });
  tracker.subscribe(event => {
    if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
      const performanceAttributes = computePerformanceAttributes(event);
      const errorAttributes = computeErrorAttributes(event);
      const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
        // Because standalone app is deployed to prod quickly,
        // we will use this attribute to query in Splunk sooner.
        isStandalone: !!(options !== null && options !== void 0 && options.isStandalone),
        hasBrowseUsersPermission: !!(options !== null && options !== void 0 && options.hasBrowseUsersPermission)
      });
      fireExperienceEvent(event.action, event.name, finalErrorDetails);
      if (event.action === 'taskFail' && options !== null && options !== void 0 && options.logErrorMessage) {
        options.logErrorMessage(`taskFail:${event.name}`, finalErrorDetails);
      }
    }
  });
  bindAll(window, [{
    type: 'unload',
    listener: () => tracker.abort({
      reason: 'Abort due to Window unloading',
      attributes: {
        cause: 'WINDOW_UNLOAD'
      }
    })
  }, {
    type: 'pagehide',
    listener: () => {
      tracker.abort({
        reason: 'Window unloading',
        attributes: {
          cause: 'PAGE_HIDE'
        }
      });
    }
  }]);
  return tracker;
}